import AdminPage from "@/pages/AdminPage";
import ChatPage from "@/pages/ChatPage";

function isAdminPath() {
  const p = window.location.pathname.replace(/\/+$/, "") || "/";
  return p === "/admin" || p.startsWith("/admin/");
}

export default function App() {
  if (isAdminPath()) {
    return <AdminPage />;
  }
  return <ChatPage />;
}
